import React, { useState } from 'react';
import MessagesBubbleAdd from 'apollo-react-icons/MessagesBubbleAdd';
import { useTranslation } from 'react-i18next';

import Button from '../Button';
import CommentsForm from './CommentForm';
import styles from './CommentToggle.module.css';

const CommentToggle = ({
  onAddComment,
  buttonText,
  hasComments = false,
  buttonContainerProps = {},
  hideTitleSeparator = false,
}) => {
  const { t } = useTranslation();
  const shouldShowFormInitially = !hasComments;
  const [showCommentForm, setShowCommentForm] = useState(
    shouldShowFormInitially
  );

  const handleAddCommentWithClose = async ({ comment, attachedFiles }) => {
    try {
      await onAddComment({
        comment,
        attachedFiles,
      });
      setShowCommentForm(false); // Close form after successful submission
    } catch (error) {
      console.error('Error adding comment:', error);
      throw error;
    }
  };

  return (
    <>
      {!showCommentForm && (
        <div {...buttonContainerProps}>
          <Button
            color="secondary"
            size="small"
            endIcon={<MessagesBubbleAdd size={11} />}
            onClick={() => setShowCommentForm(!showCommentForm)}
            className={styles.button}
            text={buttonText || t('comment')}
          />
        </div>
      )}

      {showCommentForm && (
        <CommentsForm
          onAddComment={handleAddCommentWithClose}
          onClose={() => setShowCommentForm(false)}
          hideCancelButton={!hasComments}
          hideTitleSeparator={hideTitleSeparator}
        />
      )}
    </>
  );
};

export default CommentToggle;
